import { useEffect, useRef, useState } from 'react';

type WelcomeModal = 'closed' | 'promotion';

// Uma única decisão para os avisos automáticos das duas entradas do cardápio.
export function useStoreWelcomeModal(company: any, skipPromotion = false) {
  const storeId = company?.pk;
  const closed = company?.deliveryFechado === true;
  const hasPromotion = Boolean(company?.cashbackAtivado) || (
    Array.isArray(company?.configuracoesCupom)
    && company.configuracoesCupom.some((coupon: any) => coupon?.visivel !== false)
  );
  const shown = useRef({ storeId, closed: false, promotion: false });
  const [modal, setModal] = useState<{ storeId: string; kind: WelcomeModal } | null>(null);

  useEffect(() => {
    if (shown.current.storeId !== storeId) {
      shown.current = { storeId, closed: false, promotion: false };
      setModal(null);
    }
    if (!storeId) return;

    // Cancela a promoção pendente e substitui uma promoção já aberta.
    if (closed) {
      if (!shown.current.closed) {
        shown.current.closed = true;
        setModal({ storeId, kind: 'closed' });
      }
      return;
    }

    shown.current.closed = false;
    setModal(current => current?.kind === 'closed' ? null : current);
    if (!hasPromotion || shown.current.promotion) return;
    if (skipPromotion) {
      shown.current.promotion = true;
      return;
    }
    const timeout = window.setTimeout(() => {
      shown.current.promotion = true;
      setModal({ storeId, kind: 'promotion' });
    }, 1500);
    return () => window.clearTimeout(timeout);
  }, [storeId, closed, hasPromotion, skipPromotion]);

  // A promoção nunca aparece enquanto o status atual indica pausa, nem por um render.
  const welcomeModal = modal && modal.storeId === storeId
    ? (closed ? 'closed' : (modal.kind === 'promotion' ? 'promotion' : null))
    : null;
  return { welcomeModal, dismissWelcomeModal: () => setModal(null) };
}
